import store from '@/vuex/store'
import { toLoginPage } from './redirect'
import { thisSessionNoRedirect } from './logout'
import jstz from 'jstimezonedetect'
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'
import settings from '../settings'

export function getUrlVars () {
  const vars = {}
  const param = location.search.substring(1).split('&')
  for (let i = 0; i < param.length; i++) {
    const keySearch = param[i].search(/=/)
    let key = ''
    if (keySearch !== -1) key = param[i].slice(0, keySearch)
    const val = param[i].slice(param[i].indexOf('=', 0) + 1)
    if (key !== '') vars[key] = decodeURI(val)
  }
  return vars
}

export function expectationTimeZone () {
  return jstz.determine().name()
}

export function beforeHttpHandler () {
  // フォームエラーリセット・ローダー表示
  store.dispatch('clearErrorRes')
  store.dispatch('ui', { loading: true })
}

export function successHttpHandler () {
  // フォームエラーリセット・ローダー非表示
  store.dispatch('clearErrorRes')
  store.dispatch('ui', { loading: false })
}

export function noSessionErrorHandler (error) {
  store.dispatch('ui', { loading: false })
  if (error.response) {
    if (error.response.status === 400 || error.response.status === 429 || error.response.status === 403) {
      // セッションが無い場合は403エラーはメッセージ表示用sateに入れる
      store.dispatch('errorRes', error.response.data)
    } else if (error.response.status === 401) {
      toLoginPage()
    } else if (error.response.status === 404) {
      store.dispatch('alert', { title: '404: API アドレスが見つかりません', body: error, pre: true })
    } else if (error.response.status === 500) {
      store.dispatch('alert', { title: '500: API Internal Server Error', body: error, pre: true })
    }
  } else {
    store.dispatch('alert', { title: 'APIサーバーから応答がありません', pre: true })
  }
}

export function sessionErrorHandler (error) {
  store.dispatch('ui', { loading: false })
  if (error.response) {
    if (error.response.status === 400 || error.response.status === 429) {
      if (error.response.data.non_field_errors) {
        store.dispatch('alert', { title: 'Error', body: error.response.data.non_field_errors })
      } else {
        store.dispatch('errorRes', error.response.data)
      }
    } else if (error.response.status === 401 || error.response.status === 403) {
      thisSessionNoRedirect(
        toLoginPage
      )
    } else if (error.response.status === 500) {
      store.dispatch('alert', { title: '500: API Internal Server Error', body: error.response.data, pre: true })
    }
  } else {
    store.dispatch('alert', { title: 'APIサーバーから応答がありません', pre: true })
  }
}

export function isTokenExpired () {
  /**
   * check if the access token is expired
   * @return {boolean}
   */
  const token = localStorage.getItem('token')
  const decodedToken = jwtDecode(token)
  const expirationDate = new Date(decodedToken.exp * 1000)
  return expirationDate < new Date()
}

export function updateAccessToken (successCallback, failureCallback) {
  /**
   * update the access token
   * @param {function} successCallback callback function when succeeded to refresh
   * @param {function} failureCallback callback function when failed to refresh
   */
  axios.post(
    settings.ApiUrl + 'token-refresh/',
    {
      refresh: localStorage.getItem('refresh')
    },
    { withCredentials: true }
  ).then((res) => {
    localStorage.setItem('token', res.data.access)
    if (successCallback) successCallback()
  }).catch((error) => {
    // failed to refresh the access token
    localStorage.removeItem('token')
    localStorage.removeItem('refresh')
    if (failureCallback) failureCallback()
    toLoginPage()
  })
}

export function initGoogleApi () {
  /**
   * Initialize Google API
   * reference: https://developers.google.com/identity/gsi/web/guides/use-one-tap-js-api
   */
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.addEventListener('load', () => {
      store.dispatch('ui', { googleApiLoaded: true })
      resolve(window.google)
    })
    script.addEventListener('error', () => {
      reject('Failed to load the Google 3P Authorization JavaScript Library.')
    })
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  })
}
